import React, { memo } from 'react';
import { ListCheckbox } from 'react-toolbox/lib/list'
import styles from './styles.scss'
const Checkbox = ({query, items, value, updateFilterFunc}) => {
    // adding a flag to make sure when Unspecified is the only answer, we disable the user from selecting it since it is shared by 
    // many on the product hierarchy
    var isOnlyUnspecified = Object.values(items).length === 1 && value === "Unspecified"
    var isChecked = isOnlyUnspecified ? isOnlyUnspecified : query.filter( selected => items[value].includes(selected)).length > 0

    return (
        <ListCheckbox
            checked={ isChecked }
            key={ value }
            theme={ styles } 
            caption={ value }
            onChange={ updateFilterFunc }
            disabled={ isOnlyUnspecified }
        />
    )
}
export default memo(Checkbox)